import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { NO_REFUND_POLICY_TEXT } from '../lib/storePolicies';

const TERMS_SECTIONS = [
  {
    title: 'Orders and custom requests',
    body: 'Product availability, delivery dates, and custom-order timelines are confirmed by Hunar. A request is not an accepted order until the Hunar team confirms the details with you.',
  },
  {
    title: 'Handmade variations',
    body: 'Handmade pieces can have small differences in colour, texture, size, and finish. These natural variations are part of the making process and are not defects.',
  },
  {
    title: 'Payments, delivery, and no refunds',
    body: 'You agree to provide accurate contact and delivery details and to pay the amount shown at checkout or agreed for a custom order. The delivery, payment, cancellation, and return terms shown on Hunar apply to each order.',
  },
  {
    title: 'No-refund policy',
    body: NO_REFUND_POLICY_TEXT,
  },
  {
    title: 'Your uploads and messages',
    body: 'You are responsible for images, links, and text you share in a custom-order request. Do not upload anything unlawful, private, or owned by someone else without permission.',
  },
];

export default function TermsPage() {
  const { acceptTermsOfService } = useContext(AuthContext);
  const [accepted, setAccepted] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!accepted || saving) return;

    setSaving(true);
    setError('');
    try {
      await acceptTermsOfService();
    } catch (termsError) {
      setError(termsError.message || 'Unable to save your agreement. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="container py-4 py-md-5 terms-page" aria-labelledby="terms-title">
      <div className="terms-page__shell">
        <p className="terms-page__kicker">One-time account setup</p>
        <h1 id="terms-title" className="brand-font">Terms and conditions</h1>
        <p className="terms-page__intro">
          Please read and accept these terms once before you continue using Hunar.
        </p>

        <div className="terms-page__content">
          {TERMS_SECTIONS.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </section>
          ))}
        </div>

        {error && <div className="alert alert-danger" role="alert">{error}</div>}

        <form onSubmit={handleSubmit} className="terms-page__form">
          <label className="terms-page__check">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(event) => setAccepted(event.target.checked)}
            />
            <span>I have read and agree to Hunar's terms and conditions.</span>
          </label>
          <button type="submit" className="btn btn-primary-custom" disabled={!accepted || saving}>
            {saving ? 'Saving…' : 'Agree and continue'}
          </button>
        </form>
      </div>
    </main>
  );
}
